import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    q: "¿Cómo hago un pedido?",
    a: "Añade los productos al carrito eligiendo sabor y cantidad, y pulsa «Finalizar pedido por WhatsApp». Se abrirá un chat con nosotros con tu pedido ya escrito: solo tienes que completar tus datos de envío. Te confirmamos stock, precio y entrega al momento.",
  },
  {
    q: "¿Cuánto tarda el envío?",
    a: "Los envíos a toda España tardan 24/48h laborables. En algunas zonas también ofrecemos entrega en mano por vendedor el mismo día: consúltanos por WhatsApp si tu zona está disponible.",
  },
  {
    q: "¿Qué métodos de pago aceptáis?",
    a: "Tarjeta, Bizum, transferencia bancaria, PayPal y contrareembolso (según zona). El método se acuerda contigo por WhatsApp al confirmar el pedido, sin pagos automáticos en la web.",
  },
  {
    q: "¿Los productos son originales?",
    a: "Sí, el 100% de nuestros productos son originales y verificables mediante el código de autenticidad del fabricante. Trabajamos con distribuidores oficiales desde hace más de 10 años.",
  },
  {
    q: "¿Puedo mezclar sabores en la caja de 10?",
    a: "Claro. Puedes pedir unidades sueltas o caja de 10 mezclando los sabores que quieras sin coste extra. Indícanos la mezcla por WhatsApp al confirmar el pedido.",
  },
  {
    q: "¿Es legal comprar vapers online en España?",
    a: "Sí, siempre que seas mayor de 18 años. Todos nuestros productos cumplen la normativa europea TPD y la legislación española vigente (Ley 28/2005 y RD 579/2017). Verificamos la mayoría de edad en cada pedido.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-[#1E2128]/40 px-4 py-16 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <div className="text-center">
          <p className="mb-2 text-xs font-semibold uppercase tracking-[0.3em] text-[#2EE6D6]">
            Resolvemos tus dudas
          </p>
          <h2 className="font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
            Preguntas frecuentes
          </h2>
        </div>
        <Accordion type="single" collapsible className="mt-10 space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="rounded-xl border border-[#2D323E] bg-[#1E2128] px-5"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="py-4 text-left text-sm font-semibold text-[#F2F4F6] hover:text-[#2EE6D6] hover:no-underline sm:text-base"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${i}`}
                className="text-sm leading-relaxed text-[#8A8F98]"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
